<header class="top">
    <div class="brand">
        <img class="brandHeader" [src]="headerLogoSrc" alt="Code Clairvoyance">
    </div>

    <div class="headerTheme">
        <label for="themeSelect">Theme</label>
        <select id="themeSelect" [ngModel]="theme" (ngModelChange)="onThemeChange($event)">
            <option [ngValue]="'dark'">Dark</option>
            <option [ngValue]="'light'">Light</option>
        </select>
    </div>
</header>
